/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { reportControllerDelete } from '../fn/report/report-controller-delete';
import { ReportControllerDelete$Params } from '../fn/report/report-controller-delete';
import { reportControllerFindAll } from '../fn/report/report-controller-find-all';
import { ReportControllerFindAll$Params } from '../fn/report/report-controller-find-all';
import { reportControllerFindByCommentId } from '../fn/report/report-controller-find-by-comment-id';
import { ReportControllerFindByCommentId$Params } from '../fn/report/report-controller-find-by-comment-id';
import { reportControllerFindById } from '../fn/report/report-controller-find-by-id';
import { ReportControllerFindById$Params } from '../fn/report/report-controller-find-by-id';
import { reportControllerFindByPickId } from '../fn/report/report-controller-find-by-pick-id';
import { ReportControllerFindByPickId$Params } from '../fn/report/report-controller-find-by-pick-id';
import { reportControllerMy } from '../fn/report/report-controller-my';
import { ReportControllerMy$Params } from '../fn/report/report-controller-my';
import { reportControllerSearchOffset } from '../fn/report/report-controller-search-offset';
import { ReportControllerSearchOffset$Params } from '../fn/report/report-controller-search-offset';
import { ReportDto } from '../models/report-dto';

@Injectable({ providedIn: 'root' })
export class ReportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reportControllerFindAll()` */
  static readonly ReportControllerFindAllPath = '/api/report';

  /**
   * 신고 내역 조회.
   *
   * 신고 내역을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindAll$Response(params?: ReportControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportDto>>> {
    return reportControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 신고 내역 조회.
   *
   * 신고 내역을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindAll(params?: ReportControllerFindAll$Params, context?: HttpContext): Observable<Array<ReportDto>> {
    return this.reportControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReportDto>>): Array<ReportDto> => r.body)
    );
  }

  /** Path part for operation `reportControllerSearchOffset()` */
  static readonly ReportControllerSearchOffsetPath = '/api/report/search/offset';

  /**
   * 신고 내역 오프셋 기반 조회.
   *
   * 신고 내역을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerSearchOffset$Response(params: ReportControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return reportControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 신고 내역 오프셋 기반 조회.
   *
   * 신고 내역을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerSearchOffset(params: ReportControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.reportControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `reportControllerMy()` */
  static readonly ReportControllerMyPath = '/api/report/my';

  /**
   * 회원 신고 내역 조회.
   *
   * 회원의 신고 내역을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerMy()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerMy$Response(params?: ReportControllerMy$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportDto>>> {
    return reportControllerMy(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 신고 내역 조회.
   *
   * 회원의 신고 내역을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerMy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerMy(params?: ReportControllerMy$Params, context?: HttpContext): Observable<Array<ReportDto>> {
    return this.reportControllerMy$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReportDto>>): Array<ReportDto> => r.body)
    );
  }

  /** Path part for operation `reportControllerFindById()` */
  static readonly ReportControllerFindByIdPath = '/api/report/{id}';

  /**
   * 신고 내역 ID 기반 조회.
   *
   * 신고 내역을 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindById$Response(params: ReportControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportDto>> {
    return reportControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 신고 내역 ID 기반 조회.
   *
   * 신고 내역을 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindById(params: ReportControllerFindById$Params, context?: HttpContext): Observable<ReportDto> {
    return this.reportControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReportDto>): ReportDto => r.body)
    );
  }

  /** Path part for operation `reportControllerDelete()` */
  static readonly ReportControllerDeletePath = '/api/report/{id}';

  /**
   * 신고글 삭제.
   *
   * 신고글을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerDelete$Response(params: ReportControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportDto>> {
    return reportControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 신고글 삭제.
   *
   * 신고글을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerDelete(params: ReportControllerDelete$Params, context?: HttpContext): Observable<ReportDto> {
    return this.reportControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReportDto>): ReportDto => r.body)
    );
  }

  /** Path part for operation `reportControllerFindByPickId()` */
  static readonly ReportControllerFindByPickIdPath = '/api/report/pick/{pickId}';

  /**
   * 픽 게시글 ID 기반 조회.
   *
   * 신고를 픽 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerFindByPickId()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindByPickId$Response(params: ReportControllerFindByPickId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportDto>>> {
    return reportControllerFindByPickId(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 게시글 ID 기반 조회.
   *
   * 신고를 픽 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerFindByPickId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindByPickId(params: ReportControllerFindByPickId$Params, context?: HttpContext): Observable<Array<ReportDto>> {
    return this.reportControllerFindByPickId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReportDto>>): Array<ReportDto> => r.body)
    );
  }

  /** Path part for operation `reportControllerFindByCommentId()` */
  static readonly ReportControllerFindByCommentIdPath = '/api/report/comment/{commentId}';

  /**
   * 댓글 ID 기반 조회.
   *
   * 신고를 댓글 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerFindByCommentId()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindByCommentId$Response(params: ReportControllerFindByCommentId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportDto>>> {
    return reportControllerFindByCommentId(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 ID 기반 조회.
   *
   * 신고를 댓글 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerFindByCommentId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindByCommentId(params: ReportControllerFindByCommentId$Params, context?: HttpContext): Observable<Array<ReportDto>> {
    return this.reportControllerFindByCommentId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReportDto>>): Array<ReportDto> => r.body)
    );
  }

}
